import { QueryClient } from '@tanstack/react-query';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister'

/**
 * Renegkit-specific QueryClient with optimized settings for agreements domain
 *
 * This client is isolated from the main app's QueryClient to avoid conflicts
 * and provide domain-specific caching behavior.
 */
export const renegkitQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // No retry for agreements - auth failures shouldn't retry
      retry: false,
      // Conservative cache - agreements don't change often
      // TODO(poc→real): estes defaults são do domínio de agreements. A query de
      // decisão de experiência (useOffersExperiencePolling) NÃO deve herdá-los
      // silenciosamente nem persistir no localStorage — TTL a alinhar com o time da
      // helmet (stale → refetch → nova decisão). Ver bloco C do checklist no plano.
      staleTime: 30 * 60 * 1000, // 30 minutes fresh
      gcTime: 60 * 60 * 1000, // 1 hour in memory
      // Optimize for SPA navigation
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      // Work offline if cache available
      networkMode: 'offlineFirst',
      // Prevent unnecessary refetches
      refetchOnReconnect: false,
    },

    mutations: {
      // Mutations can retry once (network issues)
      retry: 1,
      // Mutations require online connection
      networkMode: 'online',
    },
  },
});

export const persister = createAsyncStoragePersister({
  storage: window.localStorage,
})
/**
 * Clear all renegkit cache (useful for logout)
 */
export const clearAllCache = () => {
  renegkitQueryClient.clear();
};

/**
 * Get cache stats for debugging
 */
export const getStats = () => ({
  queryCount: renegkitQueryClient.getQueryCache().getAll().length,
  mutationCount: renegkitQueryClient.getMutationCache().getAll().length,
});
